/** Line discount stored as percentage (0–100). Rupee discount is computed only in UI. */

export function lineAmount(qty: number, cost: number): number {
  return Math.max(0, (Number(qty) || 0) * (Number(cost) || 0));
}

export function discountAmountFromPercent(amount: number, percent: number): number {
  const pct = Math.min(100, Math.max(0, Number(percent) || 0));
  return round2(amount * pct / 100);
}

export function netFromAmountAndPercent(amount: number, percent: number): number {
  const disc = discountAmountFromPercent(amount, percent);
  return round2(Math.max(0, amount - disc));
}

export function round2(n: number): number {
  return Math.round((Number(n) || 0) * 100) / 100;
}

export function clampDiscountPercent(percent: number): number {
  return Math.min(100, Math.max(0, Number(percent) || 0));
}

export function isTaxableFlag(isTaxable: unknown): boolean {
  return (
    (typeof isTaxable === 'string' && isTaxable === 'Y') ||
    (typeof isTaxable === 'boolean' && isTaxable)
  );
}

export interface LineGstSplit {
  cgst: number;
  sgst: number;
  igst: number;
  gstTotal: number;
}

export function gstOnNet(
  netAmount: number,
  gstRate: number,
  isIGST: boolean,
  isTaxable: unknown
): LineGstSplit {
  if (!isTaxableFlag(isTaxable) || !(Number(gstRate) > 0)) {
    return { cgst: 0, sgst: 0, igst: 0, gstTotal: 0 };
  }
  const gst = round2((netAmount * Number(gstRate)) / 100);
  if (isIGST) {
    return { cgst: 0, sgst: 0, igst: gst, gstTotal: gst };
  }
  const half = round2(gst / 2);
  return { cgst: half, sgst: half, igst: 0, gstTotal: gst };
}

export function lineTotalFromNetAndGst(netAmount: number, gst: LineGstSplit): number {
  return round2(netAmount + gst.gstTotal);
}

export function normalizeDiscountPercentOnLoad(
  storedDiscount: number,
  qty: number,
  cost: number
): number {
  const amount = lineAmount(qty, cost);
  const raw = Number(storedDiscount) || 0;
  if (amount <= 0) {
    return clampDiscountPercent(raw);
  }


  if (raw > 100 || raw > amount) {
    return round2((raw / amount) * 100);
  }
  return clampDiscountPercent(raw);
}

export function discountPercentForApi(item: { Discount?: number }): number {
  return round2(clampDiscountPercent(Number(item?.Discount ?? 0)));
}
